import { motion } from 'framer-motion';
import { useState } from 'react';
import { MenuItemModal } from './MenuItemModal';

const SWIGGY_URL = process.env.REACT_APP_SWIGGY_URL;

export const MenuItemCard = ({ item, index }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isAvailable = item.available !== false;

  const handleCardClick = () => {
    setIsModalOpen(true);
  };

  const handleOrderClick = (e) => {
    if (!isAvailable) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    e.stopPropagation();
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className={`bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all border border-brown-light/10 group cursor-pointer ${!isAvailable ? 'opacity-75' : ''}`}
        onClick={handleCardClick}
        data-testid={`menu-item-${item.id}`}
      >
        <div className="relative overflow-hidden">
          <img
            src={item.image}
            alt={item.name}
            className={`w-full h-52 object-cover transition-transform duration-500 ${isAvailable ? 'group-hover:scale-110' : 'grayscale'}`}
          />
          {!isAvailable && (
            <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
              <span className="bg-brown-dark text-white px-4 py-2 rounded-full font-bold text-sm">
                Currently Unavailable
              </span>
            </div>
          )}
          {isAvailable && (
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300 flex items-center justify-center">
              <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/90 text-brown-dark px-6 py-3 rounded-full font-bold text-sm shadow-lg">
                Quick View
              </span>
            </div>
          )}
          {item.tags && item.tags.length > 0 && (
            <div className="absolute top-3 right-3 flex flex-wrap gap-1 justify-end">
              {item.tags.slice(0, 2).map((tag, idx) => (
                <span
                  key={idx}
                  className="bg-turmeric text-brown-dark px-3 py-1 rounded-full text-xs font-bold font-caveat"
                >
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>

        <div className="p-5">
          <h3 className="text-xl font-playfair font-bold text-brown-dark mb-2">
            {item.name}
          </h3>
          <p className="text-brown-medium text-sm mb-4 line-clamp-2">
            {item.description}
          </p>
          <div className="flex items-center justify-end">
            {isAvailable ? (
              <a
                href={SWIGGY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-leaf text-white px-5 py-2 rounded-full hover:bg-leaf-hover transition-all transform hover:-translate-y-0.5 font-bold text-sm"
                onClick={handleOrderClick}
                data-testid={`order-btn-${item.id}`}
              >
                Order Now
              </a>
            ) : (
              <button
                disabled
                className="bg-gray-400 text-white px-5 py-2 rounded-full cursor-not-allowed font-bold text-sm opacity-60"
                data-testid={`order-btn-${item.id}-disabled`}
              >
                Not Available
              </button>
            )}
          </div>
        </div>
      </motion.div>

      <MenuItemModal
        item={item}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};